import request from "./request";

//获取单个博客
export async function getBlog(id) {
  return await request.get(`/api/blog/${id}`);
}
// //提交评论
// export async function postCommit(body) {
//   return await request.post("/api/comment", body);
// }

// //分页获取评论
// export async function getCommit(blogid, page = 1, limit = 10) {
//   return await request.get("/api/comment", {
//     params: {
//       blogid,
//       page,
//       limit,
//     },
//   });
// }
